
import { storage } from '../../../helpers'
import { API_URL } from '../../../config'
import { axios } from '../../../lib';
import { decoratePointOfWorks } from '../../../helpers/decoratePointOfWorks';

export const getCategories = () => {
  return axios.get(`/nomenclatures/categories`)
}

export const getDepartments = () => {
  return axios.get(`/nomenclatures/departments`)
}

export const getPointOfWorks = ({
  cif = null,
  code = null,
  searchTerm = null,
  orderByList = null,
  pageNumber = null,
  size = null
}) => {
  return axios.post('/nomenclatures/point-of-works/paginate', {
    cif,
    code,
    searchTerm,
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      orderByList
    }
  })
}

export const getPartners = ({
  pageNumber = null,
  cif=null,
  size = null,
  orderByList = null,
  searchTerm
}) => {
  return axios.post(`/nomenclatures/partners/paginate`, 
    {
      searchTerm,
      cif,
      pagination: {
        ...(pageNumber == null || size == null
          ? { pageNumber: null, size: null }
          : { pageNumber, size }),
        orderByList,
      },
    }
  );
};

export const getDecoratedPointOfWorks = async({
  cif = null,
  searchTerm = null,
}) => {
  const rawPointsOfWorks = await getPointOfWorks({cif: cif, searchTerm: searchTerm})
    const decoratedPointOfWorks = await decoratePointOfWorks(rawPointsOfWorks.content)
    return decoratedPointOfWorks
}